import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import React, { useState } from 'react';
import toArray from 'utils/toArray';
import { useCheckEventSessionAttendeesEligibility } from 'actions/eventSessions';
import UserPickerModal from 'screens/UserPickerModal';
import TeamPickerModal from 'screens/TeamPickerModal';
import ConfirmAttendeeSelectionModal from './ConfirmAttendeeSelectionModal';
import { jsx as _jsx } from "react/jsx-runtime";
export default function AddAttendeesManager(_ref) {
  var sessionId = _ref.sessionId,
    eventId = _ref.eventId,
    sessionCapacity = _ref.sessionCapacity,
    sessionAttendeesCount = _ref.sessionAttendeesCount,
    memberTypeToAdd = _ref.memberTypeToAdd,
    onClose = _ref.onClose;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    allSelectedMembers = _useState2[0],
    setAllSelectedMembers = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    pendingTeams = _useState4[0],
    setPendingTeams = _useState4[1];
  var _useState5 = useState({
      pendingMembers: [],
      conflictUsers: [],
      noAccessUsers: []
    }),
    _useState6 = _slicedToArray(_useState5, 2),
    eligibilityResult = _useState6[0],
    setEligibilityResult = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isConfirming = _useState8[0],
    setIsConfirming = _useState8[1];
  var _useCheckEventSession = useCheckEventSessionAttendeesEligibility({
      eventId: eventId,
      sessionId: sessionId
    }),
    isPending = _useCheckEventSession.isPending,
    isError = _useCheckEventSession.isError,
    checkEventSessionAttendeesEligibility = _useCheckEventSession.checkEventSessionAttendeesEligibility;
  function runEligibilityCheck(_x) {
    return _runEligibilityCheck.apply(this, arguments);
  }
  function _runEligibilityCheck() {
    _runEligibilityCheck = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
      var _yield$checkEventSess, hasAccessUsers, conflictUsers, noAccessUsers;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setIsConfirming(true);
            _context.next = 1;
            return checkEventSessionAttendeesEligibility(params);
          case 1:
            _yield$checkEventSess = _context.sent;
            hasAccessUsers = _yield$checkEventSess.hasAccessUsers;
            conflictUsers = _yield$checkEventSess.conflictUsers;
            noAccessUsers = _yield$checkEventSess.noAccessUsers;
            setEligibilityResult({
              pendingMembers: hasAccessUsers,
              conflictUsers: conflictUsers,
              noAccessUsers: noAccessUsers
            });
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _runEligibilityCheck.apply(this, arguments);
  }
  function onUserSubmit(_x2) {
    return _onUserSubmit.apply(this, arguments);
  }
  function _onUserSubmit() {
    _onUserSubmit = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref2) {
      var selectedItems, selectedUsers;
      return _regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            selectedItems = _ref2.selectedItems;
            selectedUsers = toArray(selectedItems); // Store the full selection so "Edit" can restore all selected users.
            setAllSelectedMembers(selectedUsers);
            _context2.next = 1;
            return runEligibilityCheck({
              userIds: selectedUsers.map(function (user) {
                return user.id;
              })
            });
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return _onUserSubmit.apply(this, arguments);
  }
  function onTeamSubmit(_x3) {
    return _onTeamSubmit.apply(this, arguments);
  }
  function _onTeamSubmit() {
    _onTeamSubmit = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref3) {
      var selectedItems, selectedTeams;
      return _regeneratorRuntime.wrap(function (_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            selectedItems = _ref3.selectedItems;
            selectedTeams = toArray(selectedItems); // Save selected teams so "Edit" can restore the team picker selection.
            setPendingTeams(selectedTeams);
            _context3.next = 1;
            return runEligibilityCheck({
              teamIds: selectedTeams.map(function (team) {
                return team.id;
              })
            });
          case 1:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return _onTeamSubmit.apply(this, arguments);
  }
  if (isConfirming) {
    return /*#__PURE__*/_jsx(ConfirmAttendeeSelectionModal, {
      isLoading: isPending,
      isError: isError,
      eventId: eventId,
      sessionId: sessionId,
      memberTypeToAdd: memberTypeToAdd,
      membersCount: eligibilityResult.pendingMembers.length,
      sessionCapacity: sessionCapacity,
      sessionAttendeesCount: sessionAttendeesCount,
      conflictUsers: eligibilityResult.conflictUsers,
      noAccessUsers: eligibilityResult.noAccessUsers,
      pendingMemberIds: eligibilityResult.pendingMembers.map(function (m) {
        return m.id;
      }),
      pendingTeams: pendingTeams,
      onClose: onClose,
      onEdit: function onEdit() {
        return setIsConfirming(false);
      }
    });
  }
  if (memberTypeToAdd === 'individual') {
    return /*#__PURE__*/_jsx(UserPickerModal, {
      assetId: eventId,
      eventSessionId: sessionId,
      includeDeletedUsers: false,
      usersType: "members",
      users: allSelectedMembers,
      allowSubmitWithoutChanges: allSelectedMembers.length > 0,
      onSubmit: onUserSubmit,
      onClose: onClose
    });
  }
  return /*#__PURE__*/_jsx(TeamPickerModal, {
    defaultSelectedItems: pendingTeams,
    allowSubmitWithoutChanges: pendingTeams.length > 0,
    onSubmit: onTeamSubmit,
    onClose: onClose
  });
}